import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { fmtTime } from "./meta";

const TONE = { error: "text-rose-700", warn: "text-amber-700", info: "text-slate-700" };

export function RunLog({ log }) {
  const [open, setOpen] = useState(false);
  if (!log?.length) return null;
  return (
    <Card className="overflow-hidden border-slate-200 shadow-sm" data-testid="uc-run-log">
      <button type="button" onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 px-5 py-3 text-left text-sm font-semibold text-slate-800 hover:bg-slate-50" data-testid="uc-run-log-toggle">
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />} Log <span className="text-xs font-normal text-slate-500">{log.length} lines</span>
      </button>
      {open && (
        <ol className="max-h-[40vh] space-y-0.5 overflow-auto border-t border-slate-100 bg-slate-50/60 px-5 py-3 font-mono text-[11px]" data-testid="uc-run-log-lines">
          {log.map((l, i) => <li key={i} className={TONE[l.level] || TONE.info}><span className="text-slate-400">{fmtTime(l.at)}</span> {l.msg}</li>)}
        </ol>)}
    </Card>
  );
}
